<template>
  <a-row :gutter="24" style="height: 100%; margin-bottom: 15px">
    <a-col :span="6" style="height: 100%">
      <div class="content-panle bg-white" style="height: 100%">
        <SingleTreeWithSearch
          ref="treeArea"
          :selectedData="targetOrg"
          :mixNodeName="false"
          @update:selectedOrg="handleSelectedOrg"
        ></SingleTreeWithSearch>
      </div>
    </a-col>
    <a-col :span="18" style="height: 100%">
      <div class="content-panle bg-white" style="height: 100%">
        <div style="padding-left: 12px">
          <div class=""><h3>{{ companyName }}</h3></div>
        </div>
        <div style="height: calc(100% - 75px); width: 100%">
          <a-form :form="form" @submit.prevent="handleSubmit">
            <!-- 中文名称 -->
            <a-col :span="24">
              <a-form-item>
                <a-list item-layout="horizontal">
                  <a-list-item>
                    <a-list-item-meta>
                      <span slot="title" class="list-title">
                        <h3>单位引导图列表</h3>
                      </span>
                    </a-list-item-meta>
                  </a-list-item>
                </a-list>
                <div class="upload-image-tip">人员到达单位地址后，可根据引导图进入预约地点</div>
                <a-upload
                  listType="picture"
                  accept="image/png,image/jpg,image/gif"
                  :beforeUpload="handleBeforeUploadGuideMapImg"
                  v-decorator="[
                    'guideMapList',
                    {
                      initialValue: [],
                      valuePropName: 'fileList',
                      getValueFromEvent: handleGuideMapImageChange
                    }
                  ]"
                >
                  <a-button>
                    <a-icon :type="imgUploading ? 'loading' : 'upload'"/>
                    上传引导图
                  </a-button>
                </a-upload>
              </a-form-item>
            </a-col>
            <a-col :span="24" style="margin-top: 16px;">
<!--              <a-button type="primary" html-type="submit" :loading="submitting">-->
<!--                {{ $t('userCenter.submitMiniProgSetBtn') }}-->
<!--              </a-button>-->
              <a-button @click="handleNavigationSettingShow" style="margin-left: 15px" :disabled="!canView"
                        type="danger">预览
              </a-button>
            </a-col>
          </a-form>
        </div>
      </div>
    </a-col>
    <GuideMapModal
      :model="ml"
      :visible="showImageView"
      @submit="() => showImageView = false"
      @hideModal="() => showImageView = false"
    />
  </a-row>
</template>

<script>
import { getGuideMapList } from '@/api/guideMap'
import SingleTreeWithSearch from '@/components/SingleTreeWithSearch'
import { compressImageFile } from '../../utils/utils'
import { createNavigateOrder, createGuideMap, deleteGuideMap } from '../../api/guideMap'
import { uploadBase64Img } from '@/api/fileUpload'
import GuideMapModal from './components/GuideMapModal'

export default {
  name: 'navigateSettings',
  components: {
    SingleTreeWithSearch,
    GuideMapModal
  },
  data() {
    return {
      canView: false,
      submitting: false,
      imagesIds: [],
      imgUploading: false,
      companyName: '',
      selectDeptId: '',
      showImageView: false,
      targetOrg: null, // 组织树中选中的对象
      form: this.$form.createForm(this),
      ml: []
    }
  },
  created() {

  },
  methods: {
    async getNavigateList(id) {
      let _this = this
      //加载内部引导图
      try {
        const res1 = await getGuideMapList({ deptId: id })
        let guideMapList = res1.data.collection
        let guideMapImageList = []
        let ids = []
        if (guideMapList && guideMapList.length > 0) {
          _this.canView = true
          guideMapList.forEach((item) => {
            if (!ids.includes(item.id)) {
              ids.push(item.id)
              guideMapImageList.push({
                uid: item.id,
                name: item.photoName,
                status: 'done',
                url: item.photoUrl,
                thumbUrl: item.photoUrl
              })
            }
          })
        } else {
          _this.canView = false
        }
        _this.imagesIds = ids
        this.form.setFieldsValue({
          guideMapList: guideMapImageList,
        })
      } catch (e) {
      }
    },
    handleSelectedOrg(data) {
      console.log('-------handleSelectedOrg--------', data)
      this.targetOrg = data
      this.companyName = data.name
      //设置为
      this.selectDeptId = data.id
      this.getNavigateList(data.id)
    },
    handleNavigationSettingShow() {
      let _this = this
      if (!_this.selectDeptId) {
        _this.$message.error('请先选择单位')
        return
      }
      if (_this.imagesIds.length === 0) {
        _this.$message.error('请先上传图片')
        return
      }
      _this.showImageView = true
      _this.ml = _this.form.getFieldValue('guideMapList')
      console.log( _this.ml)
    },
    // 提交图片前，验证图片大小和宽高，不符合就进行图片压缩
    async handleBeforeUploadGuideMapImg(file) {
      let options = file.type === 'image/gif' ? { maxSize: null } : { maxSize: 1024 }
      compressImageFile(file, options, this.handleUploadGuideMapImg)
      return Promise.reject()
    },
    handleGuideMapImageChange(file) {
      let _this = this
      // console.log('--handleImageFileChange--', file)
      let f = file.file
      let fileList = file.fileList
      if (f.status === 'removed') {
        if (!_this.selectDeptId) {
          _this.$notification.error({ message: '单位信息缺失' })
          return
        }
        fileList = fileList.filter((val)=>{
          return val.url !== f.url
        })

        let imageIds = _this.imagesIds

        if (imageIds.includes(f.uid)){
          imageIds = imageIds.filter((val)=>{
            return val !== f.uid
          })
          _this.imagesIds = imageIds
          createNavigateOrder({
            deptId: _this.selectDeptId,
            navigatePhotoIds: _this.imagesIds,
          }).then(res => {
            if(res.status === 200){
              deleteGuideMap(f.uid)
              _this.$notification.success({
                message: '图片删除成功'
              })
            }
          })
        }
      }
      return fileList
    },
    // 上传图片
    async handleUploadGuideMapImg(image) {

      try {
        if (!this.selectDeptId){
          this.$notification.error({
            message: '请先选择单位',
            description: ''
          })
          return Promise.reject()
        }
        this.imgUploading = true
        const base64Unhead = image.base64.replace(
          /^data:image\/\w+;base64,/,
          ''
        )
        const type = image.type.replace('image/', '')
        const res = await uploadBase64Img({
          data: base64Unhead,
          suffix: type
        })
        this.imgUploading = false
        this.$message.success(
          `${image.name} ${this.$t('userCenter.uploadSuccess')}`
        )
        let fieldsValue = this.form.getFieldsValue(['guideMapList'])
        let values = fieldsValue['guideMapList']
        values.push({
          ...image,
          url: res.data.collection[0]
        })
        let _this = this
        createGuideMap({
          photoName: '引导图',
          photoUrl: res.data.collection[0]
        }).then(res2=>{
          if (res2 && res2.status === 200) {
            let id = res2.data.collection[0]
            _this.imagesIds.push(id)
            createNavigateOrder({
              deptId: _this.selectDeptId,
              navigatePhotoIds: _this.imagesIds,
            })
            this.$notification.success({
              message: '单位引导图设置成功',
              description: ''
            })
          }
        })
        this.form.setFieldsValue({ guideMapList: values })
      } catch (error) {
        this.$message.error(`${image.name} ${this.$t('userCenter.uploadFail')}`)
        this.imgUploading = false
      }
    },

    // 提交设置
    handleSubmit() {
      let _this = this
      this.form.validateFields(async (err, values) => {
        // console.log('-----handleSubmit err-----', err)
        // console.log('-----handleSubmit values-----', values)
        if (!err) {
          try {
            this.submitting = true
            if (!_this.selectDeptId) {
              _this.$message.error('请先选择单位')
              this.submitting = false
              return
            }
            if (_this.imagesIds.length === 0) {
              _this.$message.error('请先上传图片')
              this.submitting = false
              return
            }
            //banner
            await createNavigateOrder({
              deptId: _this.selectDeptId,
              navigatePhotoIds: _this.imagesIds,
            })
            this.submitting = false
            this.$notification.success({
              message: '单位引导图设置成功',
              description: ''
            })
          } catch (error) {
            this.submitting = false
          }
        }
      })
    },
    handleRemove(file) {
      console.log(file)
    }
  }
}
</script>

<style scoped>

</style>
